import React from 'react';
import TableContext from './TableContext';

export default function useTable() {
  return React.useContext(TableContext);
}
